import { getIn } from "formik";
const TextArea = ({
  label,
  placeholder,
  name,
  formik,
  disabled,
  onChange,
  showError,
  onBlur,
  className,
}) => {
  const required = Object.keys(formik?.initialValues || {}).some((key) => key === name);
  const nestedError = getIn(formik?.errors, name);
  const nestedTouched = getIn(formik?.touched, name);

  return (
    <div className="relative w-full">
      {label && (
        <label className="block mb-1 font-semibold capitalize text-primary">
          {label} {required && <span className="text-mainRed">*</span>}
        </label>
      )}
      <div className="border-primary border  rounded-[12px] overflow-hidden flex items-center gap-1 px-2 bg-sideBar">
        <textarea
          name={name}
          placeholder={placeholder}
          onChange={onChange || (formik && formik.handleChange)}
          onBlur={onBlur || (formik && formik.handleBlur)}
          value={formik?.getFieldProps(name)?.value || ""}
          disabled={disabled}
          className={`bg-transparent focus-visible:outline-none p-4 rounded-xl w-full ${className}`}
          autoComplete="off"
        />

        {(showError || !disabled) && nestedError && (showError || nestedTouched) && (
          <span className="text-[12px] w-full left-0 text-mainRed absolute bottom-[-18px]">
            {nestedError}
          </span>
        )}
      </div>
    </div>
  );
};

export default TextArea;
